import React, { useState } from 'react';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  MenuItem,
  FormControl,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import CountryDropdown from '../components/common/CountryDropdown';



const paxTypes = [
  'Adult',
  'Child',
  'Infant',
  'Senior',
  'Student'
];

const phoneCodes = [
  { code: '+1', country: 'United States' },
  { code: '+44', country: 'United Kingdom' },
  { code: '+91', country: 'India' },
  { code: '+61', country: 'Australia' },
  { code: '+81', country: 'Japan' },
  { code: '+49', country: 'Germany' },
  { code: '+33', country: 'France' },
  { code: '+86', country: 'China' },
  { code: '+971', country: 'UAE' },
  { code: '+92', country: 'Pakistan' },
  { code: '+880', country: 'Bangladesh' },
  { code: '+234', country: 'Nigeria' },
  { code: '+55', country: 'Brazil' },
];

type Errors = {
  flightNumber?: string;
  cabinClass?: string;
  rbd?: string;
  departure?: string;
  arrival?: string;
  departureDate?: string;
  arrivalDate?: string;
  airlinePnr?: string;
  sectorType?: string;
  baggageType?: string;
  email?: string;
  paxType?: string;
  firstName?: string;
  lastName?: string;
  ticketNumber?: string;
  // Add more fields as needed
};

const ItineraryUpdate = () => {
    const [errors, setErrors] = useState<Errors>({});
    const [baggageType, setBaggageType] = useState('');
    const [sectorType, setSectorType] = useState('');
    // const [rbd, setRbd] = useState('');
    const [cabinClass, setCabinClass] = useState('');
    const [officeId, setOfficeId] = useState('');
    const [journeyType, setJourneyType] = useState('');
    const [flightType, setFlightType] = useState('');
    const [phoneCode, setPhoneCode] = useState('');
    const [title, setTitle] = useState('');
    const [profileTitle, setProfileTitle] = useState('');
    const [paxType, setPaxType] = useState('');

    const [departureDate, setDepartureDate] = useState<dayjs.Dayjs | null>(null);
    const [arrivalDate, setArrivalDate] = useState<dayjs.Dayjs | null>(null);
    const [issuedDate, setIssuedDate] = useState<dayjs.Dayjs | null>(null);
    const [expiryDate, setExpiryDate] = useState<dayjs.Dayjs | null>(null);

    const [issuedOpen, setIssuedOpen] = useState(false);
    const [expiryOpen, setExpiryOpen] = useState(false);
    const [departureOpen, setDepartureOpen] = useState(false);
    const [arrivalOpen, setArrivalOpen] = useState(false);

    const handleDepartureChange = (newValue: dayjs.Dayjs | null) => {
        setDepartureDate(newValue);
        setDepartureOpen(false);
    };

    const handleArrivalChange = (newValue: dayjs.Dayjs | null) => {
        setArrivalDate(newValue);
        setArrivalOpen(false);
    };

    const handleIssuedChange = (newValue: dayjs.Dayjs | null) => {
        setIssuedDate(newValue);
        setIssuedOpen(false);
    };

    const handleExpiryChange = (newValue: dayjs.Dayjs | null) => {
        setExpiryDate(newValue);
        setExpiryOpen(false);
    };

       const handlePaxTypeChange = (event: SelectChangeEvent) => {
            setPaxType(event.target.value);
        };

        const handleTitleChange = (event: SelectChangeEvent) => {
            setTitle(event.target.value);
        };
        const handleProfileTitleChange = (event: SelectChangeEvent) => {
            setProfileTitle(event.target.value);
        };
        const handlePhoneCodeChange = (event: SelectChangeEvent) => {
            setPhoneCode(event.target.value);
        };
        const handleFlightTypeChange = (event: SelectChangeEvent) => {
            setFlightType(event.target.value);
        };
        const handleJourneyTypeChange = (event: SelectChangeEvent) => {
            setJourneyType(event.target.value);
        };
        const handleOfficeChange = (event: SelectChangeEvent) => {
            setOfficeId(event.target.value);
        };
        const handleCabinClassChange = (event: SelectChangeEvent) => {
            setCabinClass(event.target.value);
        };
        const handleRbdChange = (event: SelectChangeEvent) => {
            setRbd(event.target.value);
        };
        const handleSectorChange = (event: SelectChangeEvent) => {
            setSectorType(event.target.value);
        };
        const handleBaggageChange = (event: SelectChangeEvent) => {
            setBaggageType(event.target.value);
        };

  const titleOptions = ['Mr.', 'Mrs.', 'Ms.'];
  const profileTitleOptions = ['Mr.', 'Mrs.', 'Ms.'];
  const flightTypes = ['One Way', 'Round Trip', 'Multi City'];
  const journeyTypes = ['Business', 'Leisure',];
  const officeIds = [
    { id: 'NYC001', location: 'New York' },
    { id: 'LDN002', location: 'London' },
    { id: 'DXB003', location: 'Dubai' },
    { id: 'BOM004', location: 'Mumbai' },
    { id: 'TKY005', location: 'Tokyo' },
];
const cabinClasses = ['Economy', 'Premium Economy', 'Business', 'First Class'];
const rbdOptions = [
  { code: 'Y', class: 'Full Economy' },
  { code: 'B', class: 'Discounted Economy' },
  { code: 'M', class: 'Mid-tier Economy' },
  { code: 'W', class: 'Premium Economy' },
  { code: 'J', class: 'Business' },
  { code: 'C', class: 'Business (Flexible)' },
  { code: 'F', class: 'First Class' },
  { code: 'A', class: 'First Class (Discounted)' },
  { code: 'H', class: 'Low Economy' },
];
const sectorTypes = [
  'Domestic',
  'International',
  'Regional',
  'Charter',
  'Intercontinental',
];
const baggageTypes = [
  'Checked Baggage',
  'Carry-On',
  'Cabin Baggage',
  'Excess Baggage',
  'Special Baggage',
  'No Baggage',
];

const [flightNumber, setFlightNumber] = useState('');
  const [rbd, setRbd] = useState('');
  const [cabin, setCabin] = useState('');
  const [departure, setDeparture] = useState('');
  const [arrival, setArrival] = useState('');
  const [airlinePnr, setAirlinePnr] = useState('');
  const [sector, setSector] = useState('');

  type Entry = {
    flightNumber: string;
    rbd: string;
    cabin: string;
    departure: string;
    arrival: string;
    airlinePnr: string;
    sector: string;
  };

  const [entries, setEntries] = useState<Entry[]>([]);

  const handleAddSegment = (e: React.FormEvent) => {
    e.preventDefault();

    const newEntry = {
      flightNumber,
      rbd,
      cabin,
      departure,
      arrival,
      airlinePnr,
      sector
    };

    setEntries([...entries, newEntry]);

    // Optional: Reset fields
    setFlightNumber('');
    setRbd('');
    setCabin('');
    setDeparture('');
    setArrival('');
    setAirlinePnr('');
    setSector('');


  if (validateFields()) {
    // All good – submit the form
    console.log('Submitting segment:', {
      flightNumber,
      cabinClass,
      rbd,
      departure,
      arrival,
      airlinePnr,
      sectorType,
    });
  } else {
    // Form has errors – do not submit
    console.warn('Validation failed');
  }
  };

//   const [profileTitle, setProfileTitle] = useState('');
//   const [paxType, setPaxType] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [ticketNumber, setTicketNumber] = useState('');
  const [email, setEmail] = useState('');

  // State to hold added entries
  type PaxEntry = {
    leadPax: string;
    paxType: string;
    firstName: string;
    lastName: string;
    ticketNumber: string;
    email: string;
  };
  const [paxEntries, setPaxEntries] = useState<PaxEntry[]>([]);

  const handleAddPax = (e: React.FormEvent) => {
    e.preventDefault();

    const newEntry = {
      leadPax: profileTitle,
      paxType,
      firstName,
      lastName,
      ticketNumber,
      email
    };

    setPaxEntries([...paxEntries, newEntry]);

    // Clear fields after adding
    setProfileTitle('');
    setPaxType('');
    setFirstName('');
    setLastName('');
    setTicketNumber('');
    setEmail('');

     if (validateField()) {
    // All good – submit the form
    console.log('Submitting segment:', {
      paxType,
      firstName,
      lastName,
      ticketNumber,
      email,
    });
  } else {
    // Form has errors – do not submit
    console.warn('Validation failed');
  }
  };

//   const profileTitleOptions = ['Mr', 'Mrs', 'Ms'];
  const paxTypes = ['Adult', 'Child', 'Infant'];

  const validateFields = () => {
  const newErrors: Errors = {};

  if (!flightNumber.trim()) newErrors.flightNumber = 'Required';
  if (!cabinClass) newErrors.cabinClass = 'Required';
  if (!rbd) newErrors.rbd = 'Required';
  if (!departure.trim()) newErrors.departure = 'Required';
  if (!arrival.trim()) newErrors.arrival = 'Required';
  if (!airlinePnr.trim()) newErrors.airlinePnr = 'Required';
  if (!sectorType) newErrors.sectorType = 'Required';

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

 const validateField = () => {
  const newErrors: Errors = {};

  if (!paxType) newErrors.paxType = 'Required';
  if (!firstName.trim()) newErrors.firstName = 'Required';
  if (!lastName.trim()) newErrors.lastName = 'Required';
  if (!ticketNumber.trim()) newErrors.ticketNumber = 'Required';
  if (!email.trim()) newErrors.email = 'Required';

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};
  return (
    <>
    <Box className="headingBtnWrap">
        <Typography variant="h1">Itinerary Update</Typography>
    </Box>
    <Box className="itineraryWrap">
        <Box className="feeModalForm">
            <Typography variant="subtitle1" gutterBottom>Flight Booking</Typography>
            <Box className="feeInputFieldWrap">
                <div className="form-control inputFieldWrap">
                    <label>Flight Type</label>
                    <FormControl sx={{ minWidth: 250 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown"
                        id="flight-type-select"
                        value={flightType}
                        onChange={handleFlightTypeChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (selected === '') {
                            return <span style={{ color: '#888' }}>Select Flight Type</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="">
                            Select Flight Type
                        </MenuItem>
                        {flightTypes.map((type) => (
                            <MenuItem key={type} value={type}>
                            {type}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Journey Type</label>
                    <FormControl sx={{ minWidth: 250 }} className="commondropdownWrap">
                        <Select
                            className="commondropdown"
                            id="journey-type-select"
                            value={journeyType}
                            onChange={handleJourneyTypeChange}
                            displayEmpty
                            renderValue={(selected) => {
                                if (selected === '') {
                                    return <span style={{ color: '#888' }}>Select Journey Type</span>;
                                }
                                return selected;
                            }}
                        >
                            <MenuItem value="">
                                Select Journey Type
                            </MenuItem>
                            {journeyTypes.map((type) => (
                                <MenuItem key={type} value={type}>
                                    {type}
                                </MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                </div>
                <div className="form-control inputFieldWrap">
                    <label>GDS PNR</label>
                    <input type="text" className="inputField" />
                </div>
            </Box>
        </Box>
        <Box className="feeModalForm">
            <Typography variant="subtitle1" gutterBottom>Booking Details</Typography>
            <Box className="feeInputFieldWrap">
                <div className="form-control inputFieldWrap">
                    <label>Office ID</label>
                    <FormControl sx={{ minWidth: 250 }} className="commondropdownWrap">
                        <Select
                            className="commondropdown"
                            id="office-id-select"
                            value={officeId}
                            onChange={handleOfficeChange}
                            displayEmpty
                            renderValue={(selected) => {
                            if (selected === '') {
                                return <span style={{ color: '#888' }}>Select Office ID</span>;
                            }
                            return selected;
                            }}
                            >
                                <MenuItem value="">
                        Select Office ID
                        </MenuItem>
                        {officeIds.map((office) => (
                            <MenuItem key={office.id} value={office.id}>
                            {office.id} ({office.location})
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                </div>
                <div className="form-control inputFieldWrap">
                    <label>GDS PNR</label>
                    <input type="text" className="inputField" />
                </div>
                <div className='searchInputFilterBox fetchPNR'>
                    <Button 
                    variant="contained"
                    className="searchBtn"
                    color="primary"
                    type="submit"
                    >
                    Fetch PNR
                    </Button>
                </div>
            </Box>
        </Box>
        <Box className="feeModalForm">
            <Typography variant="subtitle1" gutterBottom>Segment Information</Typography>
            <Box className="feeInputFieldWrap">
                <div className="form-control inputFieldWrap">
                    <label>Marketing Airline</label>
                    <input type="text" className="inputField" />
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Operating Airline</label>
                    <input type="text" className="inputField" />
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Flight Number</label>
                    <input type="text" className="inputField" value={flightNumber}
                    onChange={(e) => {
      setFlightNumber(e.target.value);
      setErrors({ ...errors, flightNumber: '' });
    }}
                     />
                     {errors.flightNumber && (
    <Typography variant="caption" color="error" style={{ display: 'block' }}>
      {errors.flightNumber}
    </Typography>
  )}
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Cabin Class</label>
                    <FormControl sx={{ minWidth: 250 }} className="commondropdownWrap">
        <Select
          className="commondropdown"
          id="cabin-class-select"
          value={cabinClass}
          onChange={(e) => {
  setCabin(e.target.value);
  handleCabinClassChange(e);
  setErrors({ ...errors, cabinClass: '' });
}}
        displayEmpty
                            renderValue={(selected) => {
                            if (selected === '') {
                                return <span style={{ color: '#888' }}>Select Cabin Class</span>;
                            }
                            return selected;
                            }}
                            >
                                <MenuItem value="">
                        Select Cabin Class
                        </MenuItem>
          {cabinClasses.map((cls) => (
            <MenuItem key={cls} value={cls}>
              {cls}
            </MenuItem>
          ))}
          
        </Select>
        {errors.cabinClass && (
    <Typography variant="caption" color="error" style={{ display: 'block' }}>
      {errors.cabinClass}
    </Typography>
  )}
      </FormControl>
                </div>
                <div className="form-control inputFieldWrap">
                    <label>RBD</label>
                    <FormControl sx={{ minWidth: 250 }} className="commondropdownWrap">
        <Select
          className="commondropdown"
          id="rbd-select"
          value={rbd}
          onChange={(e) => {
  setRbd(e.target.value);
  handleRbdChange(e);
  setErrors({ ...errors, rbd: '' });
}}
       displayEmpty
                            renderValue={(selected) => {
                            if (selected === '') {
                                return <span style={{ color: '#888' }}>Select RBD</span>;
                            }
                            return selected;
                            }}
                            >
                                <MenuItem value="">
                        Select RBD
                        </MenuItem>
          {rbdOptions.map((option) => (
            <MenuItem key={option.code} value={option.code}>
              {option.code} ({option.class})
            </MenuItem>
          ))}
        </Select>
        {errors.rbd && (
    <Typography variant="caption" color="error" style={{ display: 'block' }}>
      {errors.rbd}
    </Typography>
  )}
      </FormControl>
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Departure</label>
                    <input type="text" className="inputField" value={departure}
                    onChange={(e) => {
      setDeparture(e.target.value);
      setErrors({ ...errors, departure: '' });
    }}
                      />
                    {errors.departure && (
    <Typography variant="caption" color="error" style={{ display: 'block' }}>
      {errors.departure}
    </Typography>
  )}
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Arrival</label>
                    <input type="text" className="inputField" value={arrival}
                    onChange={(e) => {
      setArrival(e.target.value);
      setErrors({ ...errors, arrival: '' });
    }}
                      />
                    {errors.arrival && (
    <Typography variant="caption" color="error" style={{ display: 'block' }}>
      {errors.arrival}
    </Typography>
  )}
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Departure Date & Time</label>
                     <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div onClick={() => setDepartureOpen(true)}>
                        <DatePicker
                        open={departureOpen}
                        onOpen={() => setDepartureOpen(true)}
                        onClose={() => setDepartureOpen(false)}
                        value={departureDate}
                        onChange={handleDepartureChange}
                        slotProps={{ textField: { fullWidth: true } }}
                        className='datePickerWrap'
                        sx={{ minWidth: 250 }}
                        />
                    </div>
                    </LocalizationProvider>
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Arrival Date & Time</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div onClick={() => setArrivalOpen(true)}>
                        <DatePicker
                        open={arrivalOpen}
                        onOpen={() => setArrivalOpen(true)}
                        onClose={() => setArrivalOpen(false)}
                        value={arrivalDate}
                        onChange={handleArrivalChange}
                        slotProps={{ textField: { fullWidth: true } }}
                        className='datePickerWrap'
                        sx={{ minWidth: 250 }}
                        />
                    </div>
                    </LocalizationProvider>
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Departure Terminal</label>
                    <input type="text" className="inputField" />
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Arrival Terminal</label>
                    <input type="text" className="inputField" />
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Airline PNR</label>
                    <input type="text" className="inputField" value={airlinePnr}
                    onChange={(e) => {
      setAirlinePnr(e.target.value);
      setErrors({ ...errors, airlinePnr: '' });
    }}
                      />
                    {errors.airlinePnr && (
    <Typography variant="caption" color="error" style={{ display: 'block' }}>
      {errors.airlinePnr}
    </Typography>
  )}
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Sector Type</label>
                    <FormControl sx={{ minWidth: 250 }} className="commondropdownWrap">
        <Select
          className="commondropdown"
          id="sector-type-select"
          value={sectorType}
          onChange={(e) => {
            setSector(e.target.value);
            handleSectorChange(e);
            setErrors({ ...errors, sectorType: '' });
        }}
        displayEmpty
                        renderValue={(selected) => {
                        if (selected === '') {
                            return <span style={{ color: '#888' }}>Select Sector Type</span>;
                        }
                        return selected;
                        }}
                    >
                        <MenuItem value="">
                        Select Sector Type
                        </MenuItem>
          {sectorTypes.map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </Select>
        {errors.sectorType && (
          <Typography variant="caption" color="error" style={{ display: 'block' }}>
            {errors.sectorType}
          </Typography>
        )}
      </FormControl>
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Checkin Baggage</label>
                    <input type="text" className="inputField" />
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Baggage Type</label>
                    <FormControl sx={{ minWidth: 250 }} className="commondropdownWrap">
        <Select
          className="commondropdown"
          id="baggage-type-select"
          value={baggageType}
          onChange={handleBaggageChange}
          displayEmpty
          renderValue={(selected) => {
            if (selected === '') {
              return <span style={{ color: '#888' }}>Select Baggage Type</span>;
            }
            return selected;
          }}
        >
          <MenuItem value="">
            Select Baggage Type
          </MenuItem>
          {baggageTypes.map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Cabin Baggage</label>
                    <input type="text" className="inputField" />
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Meals</label>
                    <input type="text" className="inputField" />
                </div>
            </Box>
            <div className='searchInputFilterBox addBtnWrap'>
                <Button 
                variant="contained"
                className="searchBtn"
                color="primary"
                type="submit"
                onClick={handleAddSegment}
                >
                ADD
                </Button>
            </div>
        </Box>
        
          <TableContainer component={Paper} style={{ marginBottom: '20px' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Flight Number</TableCell>
                  <TableCell>RBD</TableCell>
                  <TableCell>Cabin</TableCell>
                  <TableCell>Departure</TableCell>
                  <TableCell>Arrival</TableCell>
                  <TableCell>Airline PNR</TableCell>
                  <TableCell>Sector</TableCell>
                </TableRow>
              </TableHead>
              {entries.length > 0 && (
              <TableBody>
                
                {entries.map((entry, index) => (
                  <TableRow key={index}>
                    <TableCell>{entry.flightNumber}</TableCell>
                    <TableCell>{entry.rbd}</TableCell>
                    <TableCell>{entry.cabin}</TableCell>
                    <TableCell>{entry.departure}</TableCell>
                    <TableCell>{entry.arrival}</TableCell>
                    <TableCell>{entry.airlinePnr}</TableCell>
                    <TableCell>{entry.sector}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
                )}
            </Table>
          </TableContainer>
    
        <Box className="feeModalForm">
            <Typography variant="subtitle1" gutterBottom>Profile Details</Typography>
            <Box className="feeInputFieldWrap">
                <div className="form-control inputFieldWrap">
                    <label>Title</label>
                    <FormControl sx={{ minWidth: 250 }} className="commondropdownWrap">
                            <Select
                                className="commondropdown"
                            id="title-select"
                            value={profileTitle}
                            onChange={(e) => {
  setProfileTitle(e.target.value);
  handleProfileTitleChange(e);
}}
                            displayEmpty
                                renderValue={(selected) => {
                                if (selected === '') {
                                    return <span style={{ color: '#888' }}>Select Title</span>;
                                }
                                return selected;
                                }}
                            >
                                <MenuItem value="">
                                            Select Title
                                            </MenuItem>
                            {profileTitleOptions.map((option) => (
                                <MenuItem key={option} value={option}>
                                {option}
                                </MenuItem>
                            ))}
                            </Select>
                    </FormControl>
                </div>
                <div className="form-control inputFieldWrap">
                    <label>First Name</label>
                    <input type="text" className="inputField" />
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Last Name</label>
                    <input type="text" className="inputField" />
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Phone Code</label>
                    <FormControl sx={{ minWidth: 250 }} className="commondropdownWrap">
        <Select
          className="commondropdown"
          id="phone-code-select"
          value={phoneCode}
          onChange={handlePhoneCodeChange}
          displayEmpty
                                renderValue={(selected) => {
                                if (selected === '') {
                                    return <span style={{ color: '#888' }}>Select Phone Code</span>;
                                }
                                return selected;
                                }}
        >
            <MenuItem value="">
                                            Select Phone Code
                                            </MenuItem>
          {phoneCodes.map((item) => (
            <MenuItem key={item.code} value={item.code}>
              {item.code} ({item.country})
            </MenuItem>
          ))}
        </Select>
      </FormControl>
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Mobile Number</label>
                    <input type="text" className="inputField" />
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Email Id</label>
                    <input type="text" className="inputField" value={email}
                    onChange={(e) => {
      setEmail(e.target.value);
      setErrors({ ...errors, email: '' });
    }}
                      />
                      {errors.email && (
          <Typography variant="caption" color="error" style={{ display: 'block' }}>
            {errors.email}
          </Typography>
        )}
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Confirm Email</label>
                    <input type="text" className="inputField" />
                </div>
            </Box>
        </Box>
        <Box className="feeModalForm">
            <Typography variant="subtitle1" gutterBottom>Pax Details</Typography>
            <Box className="feeInputFieldWrap">
                <div className="form-control inputFieldWrap">
                    <label>Pax Type</label>
                    <FormControl sx={{ minWidth: 250 }} className="commondropdownWrap">
                    <Select
                        className="commondropdown"
                        id="pax-type-select"
                        value={paxType}
                        onChange={(e) => {
  setPaxType(e.target.value);
  handlePaxTypeChange(e);
  setErrors({ ...errors, paxType: '' });
}}
                        displayEmpty
                        renderValue={(selected) => {
                        if (selected === '') {
                            return <span style={{ color: '#888' }}>Select Pax Type</span>;
                        }
                        return selected;
                        }}
                    >
                        <MenuItem value="">
                        Select Pax Type
                        </MenuItem>
                        {paxTypes.map((type) => (
                        <MenuItem key={type} value={type}>
                            {type}
                        </MenuItem>
                        ))}
                    </Select>
                    {errors.paxType && (
          <Typography variant="caption" color="error" style={{ display: 'block' }}>
            {errors.paxType}
          </Typography>
        )}
                    </FormControl>
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Title</label>
                    <FormControl sx={{ minWidth: 250 }} className="commondropdownWrap">
                            <Select
                                className="commondropdown"
                            id="title-select"
                            value={title}
                            onChange={handleTitleChange}
                            displayEmpty
                                renderValue={(selected) => {
                                if (selected === '') {
                                    return <span style={{ color: '#888' }}>Select Title</span>;
                                }
                                return selected;
                                }}
                            >
                                <MenuItem value="">
                                            Select Title
                                            </MenuItem>
                            {titleOptions.map((option) => (
                                <MenuItem key={option} value={option}>
                                {option}
                                </MenuItem>
                            ))}
                            </Select>
                    </FormControl>
                </div>
                <div className="form-control inputFieldWrap">
                    <label>First Name</label>
                    <input type="text" className="inputField" value={firstName}
                     onChange={(e) => {
      setFirstName(e.target.value);
      setErrors({ ...errors, firstName: '' });
    }}
                      />
                      {errors.firstName && (
          <Typography variant="caption" color="error" style={{ display: 'block' }}>
            {errors.firstName}
          </Typography>
        )}
                    
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Last Name</label>
                    <input type="text" className="inputField" value={lastName}
                     onChange={(e) => {
      setLastName(e.target.value);
      setErrors({ ...errors, lastName: '' });
    }}
                      />
                      {errors.lastName && (
          <Typography variant="caption" color="error" style={{ display: 'block' }}>
            {errors.lastName}
          </Typography>
        )}
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Date of Birth</label>
                    <input type="text" className="inputField" />
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Ticket Number</label>
                    <input type="text" className="inputField" value={ticketNumber}
                    onChange={(e) => {
      setTicketNumber(e.target.value);
      setErrors({ ...errors, ticketNumber: '' });
    }}
                      />
                      {errors.ticketNumber && (
          <Typography variant="caption" color="error" style={{ display: 'block' }}>
            {errors.ticketNumber}
          </Typography>
        )}
                </div>
            </Box>
        </Box>
        <Box className="feeModalForm">
            <Typography variant="subtitle1" gutterBottom>Passport Info</Typography>
            <Box className="feeInputFieldWrap">
                <div className="form-control inputFieldWrap">
                    <label>Passport Number</label>
                    <input type="text" className="inputField" />
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Nationality</label>
                    <CountryDropdown placeholder="Select Nationality" />
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Issued Country</label>
                    <CountryDropdown placeholder="Select Issued Country" />
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Issued Date</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div onClick={() => setIssuedOpen(true)}>
                        <DatePicker
                        open={issuedOpen}
                        onOpen={() => setIssuedOpen(true)}
                        onClose={() => setIssuedOpen(false)}
                        value={issuedDate}
                        onChange={handleIssuedChange}
                        slotProps={{ textField: { fullWidth: true } }}
                        className='datePickerWrap'
                        sx={{ minWidth: 250 }}
                        />
                    </div>
                    </LocalizationProvider>
                </div>
                <div className="form-control inputFieldWrap">
                    <label>Expiry Date</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div onClick={() => setExpiryOpen(true)}>
                        <DatePicker
                            open={expiryOpen}
                            onClose={() => setExpiryOpen(false)}
                            value={expiryDate}
                            onChange={handleExpiryChange}
                            slotProps={{ textField: { fullWidth: true } }}
                            className='datePickerWrap'
                            sx={{ minWidth: 250 }}
                        />
                        </div>
                    </LocalizationProvider>
                </div>
            </Box>
            <div className='searchInputFilterBox addBtnWrap'>
                <Button 
                variant="contained"
                className="searchBtn"
                color="primary"
                type="submit"
                onClick={handleAddPax}
                >
                ADD
                </Button>
            </div>
        </Box>
          {/* Table to display added entries */}
      
          <TableContainer component={Paper} style={{ marginBottom: '20px' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Pax Type</TableCell>
                  <TableCell>First Name</TableCell>
                  <TableCell>Last Name</TableCell>
                  <TableCell>Ticket Number</TableCell>
                  <TableCell>Email</TableCell>
                </TableRow>
              </TableHead>
              {paxEntries.length > 0 && (
              <TableBody>
                {paxEntries.map((entry, index) => (
                  <TableRow key={index}>
                    <TableCell>{entry.paxType}</TableCell>
                    <TableCell>{entry.firstName}</TableCell>
                    <TableCell>{entry.lastName}</TableCell>
                    <TableCell>{entry.ticketNumber}</TableCell>
                    <TableCell>{entry.email}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
              )}
            </Table>
          </TableContainer>
      
    </Box>
    <div className='searchInputFilterBox resetBtnWrap'>
                <Button 
                variant="contained"
                className="searchBtn"
                color="primary"
                type="submit"
                >
                RESET
                </Button>
            </div>
    </>
  )
}
export default ItineraryUpdate
